export type OfferAutoApplyVacancy = {
	reward?: {
		amountCents?: number;
		currency?: string;
	} | null;
	customer?: {
		id?: number;
		name?: string;
		autoApplicationEnabled?: boolean;
	} | null;
	remote?: boolean;
	locations?: Array<{
		id?: string;
		name?: string;
	}> | null;
	executorAutoApplicationSetting?: {
		id?: number;
		enabled?: boolean;
		remote?: boolean;
		minAmount?: {
			amountCents?: number;
			currency?: string;
		} | null;
		locations?: Array<{
			id?: string;
			name?: string;
		}> | null;
	} | null;
};

function isExecutorAutoApplyEnabled(vacancy: OfferAutoApplyVacancy): boolean {
	return (
		vacancy.executorAutoApplicationSetting?.id != null &&
		vacancy.executorAutoApplicationSetting.enabled === true
	);
}

/** Галочка — если автоотклика нет или он выключен (`enabled: false`). */
export function shouldShowOfferAutoApplyCheckbox(vacancy: OfferAutoApplyVacancy): boolean {
	return !isExecutorAutoApplyEnabled(vacancy);
}

export function shouldOfferAutoApplyPrompt(vacancy: OfferAutoApplyVacancy): boolean {
	if (!isExecutorAutoApplyEnabled(vacancy)) return true;

	const minCents = vacancy.executorAutoApplicationSetting?.minAmount?.amountCents;
	const rewardCents = vacancy.reward?.amountCents ?? 0;

	return minCents != null && rewardCents > minCents;
}

export function formatOfferAutoApplyPayment(amountCents?: number | null): string {
	if (amountCents == null) return '—';
	return `от ${(amountCents / 100).toLocaleString('ru-RU')} ₽`;
}

/** Локации + «Удалённо», например: «г Москва, Удалённо». */
export function formatOfferLocationLabel(vacancy: Pick<OfferAutoApplyVacancy, 'remote' | 'locations'>): string | null {
	const parts: string[] = [];

	const names =
		vacancy.locations?.map((location) => location.name?.trim()).filter((name): name is string => Boolean(name)) ??
		[];

	parts.push(...names);

	if (vacancy.remote) parts.push('Удалённо');

	return parts.length > 0 ? parts.join(', ') : null;
}

export function formatOfferAutoApplyAddress(vacancy: OfferAutoApplyVacancy): string {
	const names =
		vacancy.locations?.map((location) => location.name?.trim()).filter((name): name is string => Boolean(name)) ??
		[];

	const parts: string[] = [];

	if (names.length === 1) {
		parts.push(names[0]!);
	} else if (names.length > 1) {
		parts.push(`${names[0]} и ещё ${names.length - 1}`);
	}

	if (vacancy.remote) parts.push('Удалённо');

	return parts.join(', ') || '—';
}
